import type { Dispatch } from 'redux';

const version = '2';

export interface ReactNativeEventListeners {
  'react-native:unfreeze'?: () => void,
}

enum ReactNativeMethod {
  INIT = 'init',
  LOGOUT = 'logout',
  DIAL = 'dial',
  TRIGGER_VISIT = 'turbolinks-before_visit',
  NAVIGATE = 'turbolinks-load',
  SAVE_IMAGE = 'save_image',
  STAGE_SWITCH = 'switch-stage',
}

interface ReactNativePayload {
  version: string;
  method: ReactNativeMethod;
  [key: string]: any;
}

type ReduxEvent = CustomEvent<{
  reduxEventType: string;
  payload: Record<string, any>;
}>;

const sendPayload = (data: ReactNativePayload) =>
  window.ReactNativeWebView?.postMessage(JSON.stringify(data));

let dispatch: Dispatch;
let listeners: ReactNativeEventListeners;
const receiveReduxEvent = (event: ReduxEvent) => {
  if (event.detail.reduxEventType === 'dispatch') {
    dispatch(event.detail.payload.action);
  }
};

export const ReactNative = {
  exists() {
    return typeof window.ReactNativeWebView !== 'undefined';
  },

  attach(reduxDispatch: Dispatch, eventListeners: ReactNativeEventListeners = {}) {
    if (!this.exists()) return;

    dispatch = reduxDispatch;
    listeners = eventListeners;
    window.addEventListener('remote-redux', receiveReduxEvent);
    Object.entries(listeners).forEach(([key, value]) => window.addEventListener(key, value));
    sendPayload({
      version,
      method: ReactNativeMethod.INIT,
      react: true,
    });
  },

  detach() {
    if (!this.exists()) return;
    window.removeEventListener('remote-redux', receiveReduxEvent);
    Object.entries(listeners).forEach(([key, value]) => window.removeEventListener(key, value));
  },

  saveImage(imageUrl: string) {
    if (!this.exists()) return;
    sendPayload({
      version,
      method: ReactNativeMethod.SAVE_IMAGE,
      image_url: imageUrl,
    });
  },

};
